import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Spinner from "./Spinner";

import LaunchOutlinedIcon from "@material-ui/icons/LaunchOutlined";

import { usePools } from "../hooks/usePools";

import PoolDetailsModal from "./PoolDetailsModal";
import StakingModal from "./StakingModal";

import { BUY_LINK, FORMAT_APY } from "../constants/constants";

import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";
import Button from "./Button";
import OutlineButton from "./OutlineButton";
import StakingIncomeMobileCard from "./StakingIncomeMobileCard";
import ConnectWalletButton from "../../connectWalletButton";
import { useAccount } from "../../../contexts/AccountContext";

const styles = (theme) => ({
  root: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "1140px",
  },

  goBackContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "auto",

    marginBottom: "8px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "16px",
    },
  },
  goBackIcon: {
    stroke: theme?.colors?.presale?.cardTitle,
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  goBackBtn: {
    color: theme?.colors?.presale?.cardTitle,
    backgroundColor: "transparent",
    border: "none",
    fontWeight: "600",
    fontSize: "18px",
    cursor: "pointer",

    [theme.breakpoints.up("sm")]: {
      fontSize: "22px",
    },
  },
  stakingIncomeContainer: {
    width: "1100px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: "60px 40px 40px 40px",
    maxWidth: "1200px",
    minHeight: "calc(100vh - 335px)",
    [theme.breakpoints.down("675px")]: {
      padding: "20px",
    },
  },
  stakingIncomeTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "30px",
    [theme.breakpoints.down("675px")]: {
      flexDirection: "column",
    },
  },
  stakingIncomeTitleLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    [theme.breakpoints.down("675px")]: {
      alignItems: "center",
    },
  },
  stakingIncomeTitleRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("675px")]: {
      alignItems: "center",
    },
  },
  stakingIncomeAddress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    background: "none",
    border: "solid 2px #A0A0A0",
    borderRadius: "20px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
    [theme.breakpoints.down("675px")]: {
      marginRight: "0px",
    },
    "&:hover": {
      border: "solid 2px " + theme?.colors?.presale?.cardTitle,
      color: theme?.colors?.presale?.cardTitle,
    },
  },
  stakingIncomeHeading: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "32px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    [theme.breakpoints.down("675px")]: {
      fontSize: "22px",
      marginBottom: "10px",
    },
  },
  stakingIncomeSubHeading: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    [theme.breakpoints.down("675px")]: {
      fontSize: "14px",
    },
  },
  stakingIncomeSubBold: {
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingIncomeLoader: {
    width: "100%",
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "62px",
  },
  stakingIncomeList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },

  stakingIncomeMobile: {
    width: "100%",
    marginTop: "1.5rem",
    gap: "26px",
    flexDirection: "column",

    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  stakingIncomeTable: {
    width: "100%",
    marginTop: "1.5rem",
    borderCollapse: "collapse",
    borderSpacing: "0",
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",

    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "table",
    },
  },
  stakingIncomeTableMobile: {
    width: "100%",
    display: "none",
    [theme.breakpoints.down("1024px")]: {
      display: "block",
    },
  },
  tableHeader: {
    color: "#A0A0A0",
    fontSize: "14px",
    // background: "#393939",
    background: theme?.colors?.pools?.headerBackground,
    borderBottom: "1px solid " + theme?.colors?.pools?.rowBorderBottom,
    padding: "16px",
  },
  stakingIncomeTableHeader: {
    height: "50px",
    borderBottom: "solid 2px " + theme?.colors?.presale?.cardTitle,
  },
  stakingIncomeTableHeaderMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "50px",
    borderBottom: "solid 2px " + theme?.colors?.presale?.cardTitle,
    [theme.breakpoints.down("1024px")]: {
      justifyContent: "center",
    },
  },
  stakingIncomeTableTh: {
    width: "15%",
    padding: "16px",
    fontWeight: "normal",
    textAlign: "left",
  },
  tableBody: {
    background: theme?.colors?.pools?.bodyBackground,
    color: "#fff",
    width: "100%",
  },

  tableRow: {
    borderBottom: "1px solid" + theme?.colors?.pools?.rowBorderBottom,
    color: theme?.colors?.pools?.tableDataText,
  },
  tableRowLast: {
    borderBottom: "none",
    color: theme?.colors?.pools?.tableDataText,
  },
  stakingIncomeTableRowMobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "solid 2px " + theme?.colors?.presale?.cardTitle,
    width: "100%",
    padding: "10px",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  stakingIncomeTableRowMobileUp: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  stakingIncomeButtonsContainer: {
    width: "100%",
    display: "flex",
    gap: "16px",
    padding: "16px",
    alignItems: "center",
    justifyContent: "space-around",
    [theme.breakpoints.down("1024px")]: {
      justifyContent: "space-between",
    },
  },
  stakingIncomeTableTd: {
    padding: "16px",
    color: theme?.colors?.pools?.tableDataText,
  },
  stakingIncomeTableRowMobileItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Poppins",
    fontSize: "24px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textAlign: "center",
    width: "100%",
    maxWidth: "400px",
    marginBottom: "10px",
    opacity: 1,
    [theme.breakpoints.down("675px")]: {
      fontSize: "20px",
    },
  },
  stakingIncomeTableRowMobileHeadingValue: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  stakingIncomeTableImgSymbol: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  stakingIncomeTableTdImg: {
    width: "45px",

    marginRight: "10px",
    objectFit: "contain",
  },
  stakingIncomeTableTdText: {},
  connectContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  connectText: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: "600",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    marginBottom: "10px",
  },
  connectButton: {
    width: "200px",
  },
  stakingIncomeArrow: {
    width: "15px",
    height: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "10px",
  },
});

const StakingIncome = ({ classes }) => {
  const history = useHistory();
  const { address } = useParams();
  const { items: pools, approve, stake, isLoading } = usePools();
  const [detailsModal, showDetailsModal] = useState(false);
  const [stakeModal, showStakeModal] = useState(false);
  const [selectedPool, setSelectedPool] = useState(null);
  const [stakingPool, setStakingPool] = useState(null);
  const [isWaitingTrx, setIsWaitingTrx] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { account } = useAccount();

  useEffect(() => {
    if (address) {
      if (pools[address]) {
        setStakingPool(pools[address]);
        showStakeModal(true);
      } else {
        setStakingPool(null);
        showStakeModal(false);
        history.replace("/staking/pools");
      }
    }
  }, [address, history, pools]);

  const onStake = (pool) => {
    history.replace(`/staking/${pool.pool}/stake`);
  };

  const onStakeConfirm = async (pool, amount, lockUntil) => {
    setIsWaitingTrx(true);
    try {
      await stake(pool, amount, lockUntil);
      setShowSuccessModal(true);

      // setTimeout(() => {
      //   setShowSuccessModal(false);
      //   showStakeModal(false);
      //   history.replace("/staking/pools");
      // }, 4000);
    } catch (error) {
      console.error("STAKE ERROR", error);
    }
    setIsWaitingTrx(false);
  };

  const onApprove = async (pool) => {
    setIsWaitingTrx(true);
    try {
      await approve(pool);
    } catch (error) {
      console.error("APPROVE ERROR", error);
    }
    setIsWaitingTrx(false);
  };

  const onDetail = (pool) => {
    setSelectedPool(pool);
    showDetailsModal(true);
  };

  return (
    <div className={classes.root}>
      <div className={classes.goBackContainer}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          className={classes.goBackIcon}
          onClick={() => {
            history.goBack();
          }}
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>

        <button
          className={classes.goBackBtn}
          type="button"
          onClick={() => {
            history.goBack();
          }}
        >
          Go back
        </button>
      </div>
      <div className={classes.stakingIncomeTitleContainer}>
        <div className={classes.stakingIncomeTitleLeft}>
          <h1 className={classes.stakingIncomeHeading}>STAKING</h1>
          <span className={classes.stakingIncomeSubHeading}>
            The core pools in Starter Staking offer variable locking for up to{" "}
            <span className={classes.stakingIncomeSubBold}>12 months</span> and
            are shown below. Click on Details to view each pool's weight and any
            pending stakes. Learn more about our staking rewards program in our{" "}
            <a
              href="https://docs.starter.xyz/overview/staking-rewards"
              target="_blank"
              rel="noopener noreferrer"
            >
              documentation portal
            </a>
            .
          </span>
        </div>
      </div>
      {isLoading || !pools || Object.values(pools).length === 0 ? (
        <div className={classes.stakingIncomeLoader}>
          <Spinner strokeSize="6px" width="54px" height="54px" />
        </div>
      ) : (
        <div className={classes.stakingIncomeList}>
          <div>
            {account && (
              <>
                <table className={classes.stakingIncomeTable}>
                  <thead className={classes.tableHeader}>
                    <tr>
                      <th
                        style={{
                          padding: "16px",
                          borderTopLeftRadius: "32px",
                          fontWeight: "normal",
                          width: "30%",
                        }}
                      >
                        Pools
                      </th>
                      <th
                        className={classes.stakingIncomeTableTh}
                        style={{ width: "20%" }}
                      >
                        TVL
                      </th>
                      <th
                        className={classes.stakingIncomeTableTh}
                        style={{ width: "20%" }}
                      >
                        APY
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          borderTopRightRadius: "32px",
                          fontWeight: "normal",
                          width: "30%",
                        }}
                      />
                    </tr>
                  </thead>
                  <tbody className={classes.tableBody}>
                    {Object.values(pools).map((pool, index) => (
                      <tr
                        key={`pools-${pool.token.address}`}
                        className={
                          index === Object.values(pools).length - 1
                            ? classes.tableRowLast
                            : classes.tableRow
                        }
                      >
                        <td
                          style={
                            index === Object.values(pools).length - 1
                              ? {
                                  padding: "16px",
                                  borderBottomLeftRadius: "32px",
                                }
                              : { padding: "16px" }
                          }
                        >
                          <div
                            className={classes.stakingIncomeTableImgSymbol}
                            onClick={() =>
                              window.open(BUY_LINK[pool?.token?.address])
                            }
                            aria-hidden="true"
                          >
                            <img
                              src={`/tokens/${pool.token.address}.png`}
                              alt="img"
                              className={classes.stakingIncomeTableTdImg}
                            />
                            <span className={classes.stakingIncomeTableTdText}>
                              {pool?.token?.symbol}
                            </span>
                            <div className={classes.stakingIncomeArrow}>
                              <LaunchOutlinedIcon
                                style={{ width: "15px", height: "15px" }}
                              />
                            </div>
                          </div>
                        </td>
                        <td className={classes.stakingIncomeTableTd}>
                          $
                          {parseFloat(
                            pool?.tvl?.toFixed(2) || "0"
                          )?.toLocaleString()}
                        </td>
                        <td className={classes.stakingIncomeTableTd}>
                          {FORMAT_APY(pool?.apy || 0) || 0}%
                        </td>
                        <td
                          style={
                            index === Object.values(pools).length - 1
                              ? {
                                  padding: "16px",
                                  borderBottomRightRadius: "32px",
                                }
                              : { padding: "16px" }
                          }
                        >
                          <div
                            className={classes.stakingIncomeButtonsContainer}
                          >
                            <OutlineButton
                              text="Details"
                              size="md"
                              onClick={() => {
                                onDetail(pool);
                              }}
                              aria-hidden="true"
                            />
                            {isWaitingTrx ? (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                onClick={() => {
                                  // TODO: Add wait function
                                }}
                                text="Please Wait..."
                              />
                            ) : pool?.approved || pool?.external ? (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                onClick={() => {
                                  if (pool.external) 
                                    window.open(BUY_LINK[pool?.token?.address])
                                  else 
                                    onStake(pool);
                                }}
                                text="Stake"
                              />
                            ) : (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                onClick={() => {
                                  onApprove(pool);
                                }}
                                text="Approve"
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className={classes.stakingIncomeMobile}>
                  {Object.values(pools).map((pool) => (
                    <StakingIncomeMobileCard
                      pool={pool}
                      onConfirm={() => {
                        onStake(pool);
                      }}
                      onApprove={() => {
                        onApprove(pool);
                      }}
                    />
                  ))}
                </div>
              </>
            )}
            {account && (
              <div className={classes.stakingIncomeTableMobile}>
                <div className={classes.stakingIncomeTableHeaderMobile}>
                  <th className={classes.stakingIncomeTableTh}>Pools</th>
                </div>
                {Object.values(pools).map((pool) => (
                  <div
                    key={`pools-mobile-${pool.token.address}`}
                    className={classes.stakingIncomeTableRowMobile}
                  >
                    <div className={classes.stakingIncomeTableRowMobileUp}>
                      <div className={classes.stakingIncomeTableRowMobileItem}>
                        <div
                          className={classes.stakingIncomeTableImgSymbol}
                          onClick={() =>
                            window.open(BUY_LINK[pool.token.address])
                          }
                          aria-hidden="true"
                        >
                          <img
                            src={`/tokens/${pool.token.address}.png`}
                            alt="img"
                            className={classes.stakingIncomeTableTdImg}
                          />
                          <span className={classes.stakingIncomeTableTdText}>
                            {pool?.token?.symbol}
                          </span>
                          <div className={classes.stakingIncomeArrow}>
                            <LaunchOutlinedIcon
                              style={{ width: "15px", height: "15px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className={classes.stakingIncomeTableRowMobileItem}>
                        <div
                          className={
                            classes.stakingIncomeTableRowMobileHeadingValue
                          }
                        >
                          <span>TVL: </span>
                          <span>
                            $
                            {parseFloat(
                              pool?.tvl?.toFixed(2) || "0"
                            )?.toLocaleString()}
                          </span>
                        </div>
                      </div>
                      <div className={classes.stakingIncomeTableRowMobileItem}>
                        <div
                          className={
                            classes.stakingIncomeTableRowMobileHeadingValue
                          }
                        >
                          <span>APY: </span>
                          <span>{FORMAT_APY(pool?.apy || 0) || 0}%</span>
                        </div>
                      </div>
                    </div>
                    <td
                      className={classes.stakingIncomeTableTd}
                      style={{ width: "300px" }}
                    >
                      <div className={classes.stakingIncomeButtonsContainer}>
                        <OutlineButton
                          text="Details"
                          size="md"
                          onClick={() => {
                            onDetail(pool);
                          }}
                          aria-hidden="true"
                        />
                        {pool?.approved ? (
                          <Button
                            classes={{
                              root: classes.poolButton,
                              label: classes.buttonLabel,
                            }}
                            onClick={() => {
                              onStake(pool);
                            }}
                            text="Stake"
                          />
                        ) : (
                          <Button
                            classes={{
                              root: classes.poolButton,
                              label: classes.buttonLabel,
                            }}
                            onClick={() => {
                              onApprove(pool);
                            }}
                            text="Approve"
                          />
                        )}
                      </div>
                    </td>
                  </div>
                ))}
              </div>
            )}
            {!account && (
              <div className={classes.connectContainer}>
                <div className={classes.connectText}>
                  Connect your wallet to see available pools
                </div>
                <ConnectWalletButton />
              </div>
            )}
          </div>
        </div>
      )}
      <PoolDetailsModal
        modalOpen={detailsModal}
        onClose={() => {
          showDetailsModal(false);
        }}
        pool={selectedPool}
        onConfirm={() => {
          showDetailsModal(false);
          history.replace(`/staking/${selectedPool.pool}/stake`);
        }}
        onApprove={() => {
          onApprove(selectedPool);
        }}
      />

      <StakingModal
        isLoading={isWaitingTrx}
        showSuccessModal={showSuccessModal}
        modalOpen={stakeModal}
        onClose={() => {
          history.replace("/staking/pools");
          showStakeModal(false);
          setIsWaitingTrx(false);
          setShowSuccessModal(false);
        }}
        pool={stakingPool}
        onStake={(amount, lockUntil) => {
          onStakeConfirm(stakingPool, amount, lockUntil);
        }}
        onApprove={() => {
          onApprove(stakingPool);
        }}
      />
      {/* todo: OpenModal */}
      {/* <WalletModal
        modalOpen={walletModal}
        onClose={() => {
          showWalletModal(false);
        }}
      /> */}
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(StakingIncome)));
